import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Typography, Paper, IconButton, Divider
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LagbasLogo from '../components/LagbasLogo';

export default function AppSettings() {
  const { mode, setMode } = useTheme();
  const navigate = useNavigate();
  const isDark = mode === 'dark';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ backgroundColor: '#1a1a1a', color: 'white', py: 2, px: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <LagbasLogo />
          <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.2)', mx: -0.5 }} />
          <IconButton color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" fontWeight="bold">Appinstallningar</Typography>
        </Box>
      </Box>

      <Container maxWidth="sm" sx={{ mt: 4 }}>

        {/* UTSEENDE */}
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            🌓 Utseende
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Valj om appen ska visas i ljust eller morkt lage.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            {[
              { value: 'light', label: '☀️ Ljust lage', desc: 'Vit bakgrund, mork text' },
              { value: 'dark', label: '🌙 Morkt lage', desc: 'Mork bakgrund, ljus text' },
            ].map(m => (
              <Paper key={m.value} variant="outlined"
                onClick={() => setMode(m.value)}
                sx={{
                  p: 2.5, flex: 1, textAlign: 'center', cursor: 'pointer',
                  bgcolor: mode === m.value ? (isDark ? '#2a2a2a' : '#e8eaf6') : 'background.paper',
                  border: mode === m.value ? '2px solid #1a1a1a' : '1px solid',
                  borderColor: mode === m.value ? '#1a1a1a' : 'divider',
                  transition: 'all 0.2s',
                  '&:hover': { borderColor: '#1a1a1a' }
                }}>
                <Typography fontSize={28} gutterBottom>
                  {m.value === 'light' ? '☀️' : '🌙'}
                </Typography>
                <Typography variant="body2" fontWeight={mode === m.value ? 'bold' : 'normal'}>
                  {m.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {m.desc}
                </Typography>
              </Paper>
            ))}
          </Box>
        </Paper>

        {/* FRAMTIDA INSTÄLLNINGAR */}
        <Paper sx={{ p: 3, opacity: 0.5 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            🔔 Paminnelser
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body2" color="text.secondary">
            Installningar for paminnelser om CV-uppdateringar kommer snart.
          </Typography>
        </Paper>

      </Container>
    </Box>
  );
}